import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { createGumletAccount, editGumletAccount, showGumletAccount } from '../../../../../service/admin/adminGumlet.service';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toBoolean } from '../../../../../helpers/helpers';
import { setContentUpdate } from '../../../../../redux/contentUpdateSlice';
import { toast } from 'react-toastify';
import Input from '../../../../../components/form/Input';
import formValidationRules from '../../../../../helpers/formvalidationRules';
import FormButton from '../../../../../components/button/FormButton';

export default function GumletAccountCE(props:{type:any,isOpen:any, data?: any}) {
     const [pageLoad, setPageLoad] = useState(false);
      const [fetchData, setFetchData] = useState<any>();
      const [loading, setLoading] = useState(false);
      const [pageContent, setPageContent] = useState({
        button: 'Create New Account',
        title: 'Create Account',
      });
      const dispatch = useDispatch();
        const fetchDa = async (id: string) => {
          let get: any = await showGumletAccount(id);
          if (get?.status === 'success') {
            setFetchData(get?.message);
          }
        };
        useEffect(() => {
          if (props.type === 'edit') {
            fetchDa(props.data);
            setPageContent({
              button: 'Update  Account',
              title: 'Update Account',
            });
          }
        }, []);

        const { handleSubmit, control } = useForm<any>({
            values: {
              name: fetchData?.name,
              token: fetchData?.token,
            },
          });
const onSubmit: SubmitHandler<any> = async (data:any) => {  
    setLoading(true);
    let fetch: any;
    if (props.type === 'create') {
      fetch = await createGumletAccount(data.name, data.token);
    }
    if (props.type === 'edit') {
      fetch = await editGumletAccount(props.data, data.name, data.token);
    }
    if (fetch?.status === 'success') {
      dispatch(
        setContentUpdate({
          id: Math.random() * (100000 - 111111),
        })
      );
      setLoading(false);
      props.isOpen(false);
      return toast.success(fetch.message);
    }
    setLoading(false);
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
        <Input
          name="name"
          control={control}
          rules={{
            ...formValidationRules.required(),
            ...formValidationRules.minLength(3),
          }}
          label="Account Name"
          placeholder="account name"
        />
        <Input
          name="token"
          control={control}
          rules={{
            ...formValidationRules.required(),
            ...formValidationRules.minLength(3),
          }}
          label="Account Token"
          placeholder="account token"
        />
       
        <FormButton loading={loading} title={pageContent.button} />
      </form>
    </>
  )
}
